module.exports = __webpack_public_path__ + "img/live.a59c6301.png";